import {LayoutPricingComparison} from './LayoutPricingComparison';
import {LayoutPricingItems} from './LayoutPricingItems';
import {LayoutPricingOverview} from './LayoutPricingOverview';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Pricing';

export const PricingComparison = {
  category,
  displayName: 'Pricing Comparison',
  previewImageURL: prebuiltLayoutPreviewImages.layoutPricingComparison,
  layout: LayoutPricingComparison,
};

export const PricingItems = {
  category,
  displayName: 'Pricing Items',
  previewImageURL: prebuiltLayoutPreviewImages.layoutPricingItems,
  layout: LayoutPricingItems,
};

export const PricingOverview = {
  category,
  displayName: 'Pricing Overview',
  previewImageURL: prebuiltLayoutPreviewImages.layoutPricingOverview,
  layout: LayoutPricingOverview,
};
